import React, { useState } from "react";
import { useScript } from "../../util/customHooks";

export default function THEOlivePlayer(props) {
    const channelId = props.channelId;
    const token = props.token;
    const status = useScript(props.scriptSrc || 'https://cdn.theo.live/player/embed.js',true);
    const [playerStarted,setPlayerStarted] = useState(false);
    const [isErr,setIsErr] = useState(false);
    const [errMsg,setErrMsg] = useState(null);

    if (typeof window.THEOLive !== 'undefined' && status == 'ready'  && channelId && !playerStarted ) {
        const THEOLive = window.THEOLive;
        if (THEOLive.requiresServiceWorker()) {
            navigator.serviceWorker.register('THEOLive.sw.js')
        }
        const headerProvider = (url) => {
            return new Headers({
              'Authorization': `Bearer ${token}`
            });
          }
        const player = new THEOLive.Player(document.getElementById('player'));
        player.addHeaderProvider(headerProvider);
        player.loadChannel(channelId).then(() => {
            player.play(); // not required if your channel is configured as autoplay
            setPlayerStarted(true);
        }).catch(err => {console.error(err); setIsErr(true); });
    }

    return (
        <>
        {isErr?
                errMsg || 'Error loading stream, something went wrong'
        :
            <>{channelId && 
                <>
                {!playerStarted? 'Starting player...' :''}
                <div id='player' style={ { width: '80vw', margin: 'auto'} } ></div>
                </>
            
            }
            </>
        }
        </>
    )
}